import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '@services/security';

@Pipe({
    name: 'showInclusionType',
})
export class ShowInclusionTypePipe implements PipeTransform {
    constructor(private authService: AuthService) {}

    transform(patient: any, type: any): boolean {
        return patient?.inclusion?.type === type || this.authService.isAdmin || patient?.companyId?.inclusionTypes.includes(type);
    }
}
